<cache-date></cache-date>

<ng-container *ngIf="rebuilding?.status">
	<h1>{{ 'adminstat.users.group_ref_new.Manage groups of traffic sources' | translate }}</h1>
	
	<br><br><hr><br><br>
	
	<strong>
		<h3>{{ 'adminstat.common.rebuildingReferers' | translate }}</h3>
		<br>{{ rebuilding.dateStart }}
	</strong>
	
	<br><br>
	
	<div class="progress">
		<div class="progress-bar progress-bar-striped active" role="progressbar" attr.aria-valuenow="{{rebuilding.procent}}" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': rebuilding.procent + '%'}">
			{{ rebuilding.procent }}%
		</div>
	</div>
</ng-container>

<ng-container *ngIf="!rebuilding?.status">
	<h1>{{ 'adminstat.users.group_ref_new.Manage groups of traffic sources' | translate }}</h1>
	
	<br><br>
	
	<button type="button" class="btn btn-danger" (click)="rebuild()" *ngIf="groupRefService.canRunRebuild()">Rebuild</button>
	
	<hr><br><br>
	
	<div class="row">
		<div class="col-md-4">
			<h3>{{ 'adminstat.users.group_ref_new.traffic groups' | translate }}</h3>
			
			<br>
			
			<table *ngIf="groupsBusy?.isStopped" class="table table-bordered js-ul-group-global-table">
				<thead>
					<tr>
						<th>{{ 'adminstat.users.group_ref_new.GroupName' | translate }}</th>
						<th></th>
						<th></th>
					</tr>
				</thead>
				
				<tbody [sortablejs]="groups" [sortablejsOptions]="groupsSortOptions">
					<tr *ngFor="let group of groups">
						<td
							[style.background-color]="currentGroup && group.name == currentGroup.name ? '#5cb85c' : null"
						>
							<button
								type="button"
								class="btn btn-link" 
								(click)="openGroup(group.id)"
								[style.color]="currentGroup && group.name == currentGroup.name ? 'white' : null"
							>
								{{ group.name}}
							</button>
							
							<span
								class="badge badge-info"
								*ngIf="group.isPaid"
								title="применяться для платежных рефереров"
							>
								paid
							</span>
						</td>
						
						<td>
							<i class="fas fa-pencil-alt" aria-hidden="true" (click)="editGroup(group.id)"></i>
						</td>
						
						<td>
							<i class="fas fa-times" aria-hidden="true" (click)="deleteGroup(group.id)"></i>
						</td>
					</tr>
				</tbody>
			</table>

			<button type="button" class="btn btn-secondary" style="float:left;" (click)="addGroup()">
				{{ 'adminstat.users.group_ref_new.Add group' | translate }}
			</button>
			
			<br><br>
		</div>
		
		<div class="col-md-8">
			<h3>{{ 'adminstat.users.group_ref_new.ref sources' | translate }}</h3>
			
			<br>
			
			<table *ngIf="currentGroup && sourcesBusy?.isStopped" class="table js-ul-ref-global-table">
				<thead>
					<tr>
						<th>{{currentGroup.name}}</th>
					</tr>
				</thead>
				
				<tbody [sortablejs]="sources" [sortablejsOptions]="sourcesSortOptions">
					<tr *ngFor="let source of sources; let sourceIndex = index">
						<td>
							<table class="table js-ul-ref-global-table">
								<thead>
									<tr style="background-color: #d9edf7;">
										<td>
											<div class="row">
												<div class="col-md-8">
													<div class="form-group">
														<div class="input-group">
															<input type="text" size="130" [(ngModel)]="source.name" class="form-control" [disabled]="!source.isSourceEdit">
															<div class="input-group-append" *ngIf="!source.isSourceEdit">
																<div class="input-group-text" #popoverPreview="ngbPopover" [ngbPopover]="popContent" (mouseenter)="loadSource(sourceIndex); popoverPreview.open()" (mouseleave)="popoverPreview.close()">
																	<i class="fas fa-eye" aria-hidden="true"></i>
																</div>
															</div>

															<ng-template #popContent>
																<div *ngIf="previewRules.length > 0">
																	<ul class="list-group list-group-flush">
																		<li class="list-group-item" *ngFor="let previewRule of previewRules; let ruleIndex = index">
																			<b >{{ 'adminstat.filterForm.' + (previewRule.exprId == 0 ? 'and' : 'or') | translate }}</b>
																			{{previewRule.filter}} {{previewRule.state}} <var>{{previewRule.text}}</var>
																		</li>
																	</ul>
																</div>
															</ng-template>
														</div>
													</div>
												</div>
												<div class="col-md-4">
													<div class="btn-group" role="group" aria-label="Basic example">
														<button type="button" class="btn btn-secondary" *ngIf="source.isSourceEdit == false">
															<i class="fas fa-pencil-alt" aria-hidden="true" (click)="editSource(sourceIndex)"></i>
														</button>
														<button type="button" class="btn btn-secondary" *ngIf="source.isSourceEdit == true">
															<i class="fas fa-save" aria-hidden="true" (click)="saveSource(source.id, sourceIndex)"></i>
														</button>
														<button type="button" class="btn btn-secondary">
															<i class="fas fa-times" aria-hidden="true" (click)="deleteSource(source.id, sourceIndex)"></i>
														</button>
													</div>
												</div>
											</div>
										</td>
									</tr>
									
									<tr *ngIf="rulesBusy[sourceIndex] && !rulesBusy[sourceIndex]?.isStopped && source.isSourceEdit">
										<td>
											<!--<div class="loader">-->
												<!--<img src="/img/loader.svg" class="img-responsive center-block">-->
											<!--</div>-->
										</td>
									</tr>
								</thead>
								
								<tbody id="RuleView" *ngIf="source.isSourceEdit && rulesBusy[sourceIndex]?.isStopped">
									<tr *ngFor="let rule of source.rules; let ruleIndex = index">
										<td class="js-rule-row"
											[style.border-left]="rule.isExpr ? '1px solid' : null"
											[style.border-right]="rule.isExpr ? '1px solid' : null"
											[style.border-top]="rule.isExpr && rule.exprStart ? '1px solid' : null"
											[style.margin-top]="rule.isExpr && rule.exprStart ? '2px' : null"
											[style.border-bottom]="rule.isExpr && !rule.exprStart && rule.exprEnd ? '1px solid' : null"
											[style.margin-bottom]="rule.isExpr && !rule.exprStart && rule.exprEnd ? '2px' : null"
										>
											<div class="row">
												<div class="col-md-1">
													<sup *ngIf="!(rule.isExpr == true && rule.exprStart == true)">
														<b *ngIf="rule.exprId == 0">{{ 'adminstat.filterForm.and' | translate }}</b>
														<b *ngIf="rule.exprId != 0">{{ 'adminstat.filterForm.or' | translate }}</b>
													</sup>
												</div>
												
												<div class="col-md-2">
													<select class="form-control js-referer-rule-filter-list" width="90" [(ngModel)]="rule.filter">
														<option></option>
														<option *ngFor="let opt of ['referal', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_landing']" [selected]="rule.filter == opt">
															{{ opt }}
														</option>
													</select>
												</div>
												
												<div class="col-md-2">
													<select class="form-control js-referer-rule-state-list" [(ngModel)]="rule.state">
														<option></option>
														<option *ngFor="let opt of ['empty', 'equal', 'contains', 'starts', 'ends', 'regexp', 'not empty', 'not equal', 'not contains', 'not start', 'not end', 'not regexp']" [selected]="rule.state == opt">
															<!--{{ 'users.group_ref_new.' + opt | translate }}-->
															{{ opt }}
														</option>
													</select>
												</div>
												
												<div class="col-md-4">
													<input type="text" [(ngModel)]="rule.text" class="form-control js-referer-rule-text" [disabled]="rule.state == 'empty' || rule.state == 'not empty'">
												</div>
												
												<div class="col-md-3">
													<div class="btn-group" role="period" style="float:right;">
														<button type="button" class="btn btn-secondary" (click)="deleteRule(ruleIndex, sourceIndex)">
															<i class="fas fa-times" aria-hidden="true"></i>
														</button>

														<button type="button" class="btn btn-secondary" (click)="addRule('or', ruleIndex, sourceIndex)" [disabled]="rule.isExpr == true && rule.exprEnd != true">
															{{ 'adminstat.filterForm.or' | translate }}
														</button>

														<button type="button" class="btn btn-secondary" (click)="addRule('and', ruleIndex, sourceIndex)" [disabled]="rule.isExpr == true && rule.exprEnd != true">
															{{ 'adminstat.filterForm.and' | translate }}
														</button>
													</div>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
				</tbody>
			</table>

			<button type="button" class="btn btn-secondary" *ngIf="currentGroup" style="float:right;" (click)="addSource()">
				{{ 'adminstat.users.group_ref_new.Add new source' | translate }}
			</button>
			
			<br><br>
		
		</div>
	</div>
</ng-container>
